import { useCallback, useState } from "react";
import { designerCanvasStore } from "../stores/designerCanvasStore.ts";
import { getLayers } from "../utils/layer.ts";
import { useCanvasEventsListener } from "./useCanvasEventsListener.ts";

export const useLayers = () => {
  const { fabricCanvas } = designerCanvasStore.useState((it) => ({
    fabricCanvas: it.fabricCanvas,
  }));

  const [layersUpdateCount, setLayersUpdateCount] = useState(0);

  // XXX:The original hook only used designerCanvasStore.useState() which only re-renders
  // when the store state changes. Since the store only holds a reference to fabricCanvas
  // (not the actual layers array), adding/removing layers via fabricCanvas.add()/remove()
  // doesn't trigger store updates, so the hook never refreshes.
  // To fix this, we maintain a local `layersUpdateCount` counter that increments whenever
  // fabric canvas fires "object:added" or "object:removed" events. When `layersUpdateCount` changes,
  // React re-renders the component and recalculates the layers array via getLayers(fabricCanvas).
  // This ensures the hook stays in sync with the actual canvas state without modifying the store
  // by adding extra properties `layersCount` that need to be maintained and synced with the canvas.
  const layers =
    fabricCanvas && layersUpdateCount >= 0 ? getLayers(fabricCanvas) : [];

  const handleCanvasEvent = useCallback(() => {
    setLayersUpdateCount((prev) => prev + 1);
  }, []);

  useCanvasEventsListener({
    eventTypes: [
      "object:added",
      "object:removed",
      "canvas:objects:reordered",
      "object:visibility:changed",
      "layer:renamed",
    ],
    onEvent: handleCanvasEvent,
    canvas: fabricCanvas,
  });

  return layers;
};
